import ErrorBoundaryRoutes from "app/shared/error/error-boundary-routes";
import { Route } from "react-router-dom";
import CaseSubmission from "app/edozvola/case-submission/case-submission";
import { IRootState } from "app/config/store";
import { connect } from "react-redux";
import React from "react";

const CaseSubmissionRoutes = () => {
  return (
    <ErrorBoundaryRoutes>
      <Route index element={ <CaseSubmission/> }/>
    </ErrorBoundaryRoutes>
  );
}

const mapStateToProps = ({}: IRootState) => ( {} );
export default connect(mapStateToProps, null)(CaseSubmissionRoutes);
